import React, { Fragment } from "react";
import HomeComponent from "../component/app/home/Home.component";
import { useAuth } from "../context/Auth.context";
// import DealershipDetailComponent from "../component/app/admin/dealership/DealershipDetail.component";
import DealershipUsercomponent from "../component/app/admin/dealership/DealershipUser.component";

const DealershipUserPage = () => {
  const auth = useAuth();

  return (
    <Fragment>
      <DealershipUsercomponent />
    </Fragment>
  );
};

export default DealershipUserPage;
